/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_Step4Inputs */

const en_gc_resources_guide_analysis_step4 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the summary: Travel should total 165 and Supplies 85. Save the workbook and reopen a copy to verify the result.`)
};

const zh_gc_resources_guide_analysis_step4 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查汇总结果：Travel 应为 165，Supplies 应为 85。保存工作簿，再重新打开副本验证结果。`)
};

/**
* | output |
* | --- |
* | "Check the summary: Travel should total 165 and Supplies 85. Save the workbook and reopen a copy to verify the result." |
*
* @param {Gc_Resources_Guide_Analysis_Step4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_step4 = /** @type {((inputs?: Gc_Resources_Guide_Analysis_Step4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_Step4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_step4(inputs)
	return zh_gc_resources_guide_analysis_step4(inputs)
});
export { gc_resources_guide_analysis_step4 as "gc.resources.guide.analysis.step4" }